import { Link } from 'react-router-dom'
import { Clock, MapPin, Phone } from 'lucide-react'
import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { hotel, whatsappLink } from '@/data/hotel'

const NAV_LINKS = [
  { to: '/', label: 'Início' },
  { to: '/sobre', label: 'Sobre' },
  { to: '/galeria', label: 'Quartos' },
  { to: '/servicos', label: 'Serviços' },
  { to: '/contato', label: 'Contato' },
]

const SOCIAL_LINKS = [
  { href: hotel.facebook, label: 'Facebook', icon: FaFacebook },
  { href: hotel.instagram, label: 'Instagram', icon: FaInstagram },
  { href: whatsappLink(), label: 'WhatsApp', icon: FaWhatsapp },
]

function FooterHeading({ children }) {
  return (
    <h3 className="mb-5 font-sans text-xs font-bold tracking-[0.2em] text-highlight uppercase">
      {children}
    </h3>
  )
}

function Footer() {
  return (
    <footer className="bg-ink-texture text-ink-foreground">
      <div className="container-page py-16">
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1.2fr_1.2fr]">
          {/* Sobre */}
          <div className="flex flex-col gap-5">
            <h3 className="text-2xl font-bold">Star Hotel</h3>
            <p className="max-w-xs text-sm leading-relaxed text-ink-foreground/70">
              Atendimento com carinho e dedicação para tornar sua estadia inesquecível, no
              coração de Limoeiro-PE.
            </p>
            <div className="flex gap-2">
              {SOCIAL_LINKS.map(({ href, label, icon: Icon }) => (
                <Button key={label} asChild variant="glass" size="icon-lg" className="rounded-full">
                  <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                    <Icon />
                  </a>
                </Button>
              ))}
            </div>
          </div>

          {/* Navegação */}
          <div>
            <FooterHeading>Navegação</FooterHeading>
            <ul className="flex flex-col gap-3 text-sm text-ink-foreground/70">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-ink-foreground">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <FooterHeading>Contato</FooterHeading>
            <ul className="flex flex-col gap-4 text-sm text-ink-foreground/70">
              <li className="flex items-start gap-3">
                <Phone className="mt-0.5 size-4 shrink-0 text-highlight" />
                <span>
                  {hotel.phoneDisplay}
                  <br />
                  {hotel.whatsappDisplay}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 size-4 shrink-0 text-highlight" />
                <span>{hotel.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="mt-0.5 size-4 shrink-0 text-highlight" />
                <span>Recepção 24 horas</span>
              </li>
            </ul>
          </div>

          {/* Reserva */}
          <div>
            <FooterHeading>Faça sua reserva</FooterHeading>
            <p className="mb-5 text-sm text-ink-foreground/70">
              Fale com a gente agora mesmo pelo WhatsApp e garanta sua estadia.
            </p>
            <Button asChild variant="highlight" size="xl">
              <a href={whatsappLink()} target="_blank" rel="noopener noreferrer">
                <FaWhatsapp data-icon="inline-start" />
                Chamar no WhatsApp
              </a>
            </Button>
          </div>
        </div>

        <Separator className="my-10 bg-ink-foreground/10" />

        <p className="text-center text-sm text-ink-foreground/50">
          &copy; {new Date().getFullYear()} Star Hotel. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  )
}

export default Footer
